/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
          <el-form-item label="搜索：">
           <!-- <el-select size="small" v-model="formInline.isLock" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option label="正常" value="N"></el-option>
              <el-option label="已锁定" value="Y"></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="">
            <el-input size="small" v-model="formInline.name" placeholder="输入菜单名称关键字"></el-input>
          </el-form-item>
    	  <el-form-item label="">
    	    <el-input size="small" v-model="formInline.parentMenuCode" placeholder="输入父级菜单编码或关联权限的菜单编码"></el-input>
    	  </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
          </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" @selection-change="selectChange" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="50">
          </el-table-column>
          <el-table-column align="center" sortable prop="menuName" label="菜单名" width="120">
          </el-table-column>
          <el-table-column align="center" sortable prop="menuCode" label="菜单编码" width="120">
          </el-table-column>
    	  <el-table-column align="center" sortable prop="type" label="菜单类型" width="100">
    	  </el-table-column>
		  <el-table-column align="center" sortable prop="parentCode" label="父节点" width="120">
		  </el-table-column>
          <el-table-column align="center" sortable prop="createTime" label="创建时间" min-width="140">
          </el-table-column>
		  <el-table-column align="center" sortable prop="updateTime" label="修改时间" min-width="140">
		  </el-table-column>
         <!-- <el-table-column align="center" sortable prop="editTime" label="修改时间" min-width="120">
            <template slot-scope="scope">
              <div>{{scope.row.editTime|timestampToTime}}</div>
            </template>
          </el-table-column> -->
          <el-table-column align="center" sortable prop="status" label="状态" min-width="100">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status=='1'?nshow:fshow" active-color="#13ce66" inactive-color="#ff4949" @change="editType(scope.$index, scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="400">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
			  <el-button size="mini" type="success" @click="getdatas(scope.$index, scope.row.menuCode)">加载子菜单</el-button>
			  <el-button size="mini" type="success" @click="getdatas(scope.$index, '')">返回上级节点</el-button>
			  <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
              <!-- <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
              <el-button size="mini" type="success" @click="resetpwd(scope.$index, scope.row)">重置密码</el-button>
              <el-button size="mini" type="success" @click="dataAccess(scope.$index, scope.row)">数据权限</el-button>
              <el-button size="mini" type="success" @click="offlineUser(scope.$index, scope.row)">下线</el-button>
              <el-button size="mini" type="success" @click="refreshCache(scope.$index, scope.row)">刷新缓存</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click='closeDialog("edit")'>
          <el-form label-width="80px" ref="editForm" :model="editForm" :rules="rules">
            <el-form-item label="菜单名" prop="menuName">
              <el-input size="small" v-model="editForm.menuName" auto-complete="off" placeholder="请输入菜单名"></el-input>
            </el-form-item>
            <el-form-item label="菜单编码" prop="menuCode">
              <el-input size="small" v-model="editForm.menuCode" auto-complete="off" placeholder="请输入菜单编码"></el-input>
            </el-form-item>
            <el-form-item label="父节点" prop="parentCode">
              <el-select size="small" v-model="editForm.parentCode" placeholder="请选择父节点" class="userRole">
              		<el-option v-for="(item,index)  in userData" :key="index" :label="item.menuName" :value="item.menuCode"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态" :prop="editForm.status">
              <el-radio v-model="editForm.status" label="1">启用</el-radio>
              <el-radio v-model="editForm.status" label="0">禁用</el-radio>
            </el-form-item>
    		<el-form-item label="菜单排序" prop="sorted">
    		    <el-input size="small" v-model="editForm.sorted" placeholder="请输入菜单排序"></el-input>
    		</el-form-item>
			<el-form-item label="图标" prop="icon">
			    <el-input size="small" v-model="editForm.icon" placeholder="请输入图标"></el-input>
			</el-form-item>
			<el-form-item label="菜单页面地址" prop="uri">
			    <el-input size="small" v-model="editForm.uri" placeholder="请输入应用菜单页面地址"></el-input>
			</el-form-item>
    		<el-form-item label="应用类型" prop="type">
    		  <el-select size="small" v-model="editForm.type" placeholder="请选择应用类型" class="userRole">
    		  		<el-option v-for="(item,index) in typelist" :key="index" :label="item.typeName" :value="item.typeCode"></el-option>
    		  </el-select>
    		</el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
            <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
          </div>
        </el-dialog>
      </div>
    </template>

    <script>
    // 导入请求方法
    import {
      ModuleNodes,
	  ModuleGet,
	  ModuleSave,
	  ModuleAdd,
	  Modulestate,
	  ModuleDelete
    } from '../../api/userMG'
    import Pagination from '../../components/Pagination'
    import {options} from "@/utils/city"
    export default {
      data() {
        return {
          nshow: true, //switch开启
          fshow: false, //switch关闭
          loading: false, //是显示加载
          title: '添加用户',
          editFormVisible: false, //控制编辑页面显示与隐藏
          dataAccessshow: false, //控制数据权限显示与隐藏
          unitAccessshow: false, //控制所属单位隐藏与显示
          // 编辑与添加
          editForm: {
            parentCode: '',
            menuName: '',
            sorted: '',
            menuCode: '',
            type: '',
            status: '',
			icon:'',
			uri:'',
			url:'',

          },
    	  options:  options,

		  typelist:[
			  {typeCode:"WEB",typeName:"PC端"},
			  {typeCode:"WX_APP",typeName:"微信端"}
		  ],
          // 选择数据
          selectdata: [],
          // rules表单验证
          rules: {
            account: [
              { required: true, message: '请输入用户名', trigger: 'blur' }
            ],
            name: [
              { required: true, message: '请输入姓名', trigger: 'blur' }
            ],
            roleCodeList: [{ required: true, message: '请选择角色', trigger: 'blur' }],
            phoneNumber: [
              { required: true, message: '请输入手机号', trigger: 'blur' },
              {
                pattern: /^1(3\d|47|5((?!4)\d)|7(0|1|[6-8])|8\d)\d{8,8}$/,
                required: true,
                message: '请输入正确的手机号',
                trigger: 'blur'
              }
            ],
            email: [
              { required: true, message: '请输入邮箱', trigger: 'blur' },
              {
                pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
                required: true,
                message: '请输入正确的邮箱',
                trigger: 'blur'
              }
            ]
          },

          // 请求数据参数
          formInline: {
            pageIndex: 1,
            pageSize: 10,
            name: '',
            parentMenuCode: ''
          },
    	  formrole: {
    	    pageIndex: 1,
    	    pageSize: 10,
    	    roleCode: '',
    	    name: ''
    	  },
          //用户数据
          userData: [],
          // 数据权限
          UserDept: [],
          defaultProps: {
            children: 'children',
            label: 'name'
          },
          // 选中
          checkmenu: [],
          //参数role
          saveroleId: '',
          // 分页参数
          pageparm: {
            currentPage: 1,
            pageSize: 10,
            total:10
           
          }
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        this.getdata(this.formInline)
      },

      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {

		  // 获取数据方法
		  getdatas(index, row) {
		    this.loading = true

		    let pageparm= {
		      pageIndex: 1,
		      pageSize: 10,
		     name: '',
		     parentMenuCode:''
		    }
		    console.log(777,row)
		    if(row != undefined && row != 'undefined'){
		  	  pageparm.parentMenuCode = row
		    }

		    ModuleNodes(pageparm).then(res => {
		      this.loading = false
		      if (res.success == false) {
		        this.$message({
		          type: 'info',
		          message: res.msg
		        })
		      } else {
		        this.userData = res.data.menuList

		        // 分页赋值
		        this.pageparm.currentPage = this.formInline.pageIndex
		        this.pageparm.pageSize = this.formInline.pageSize
		        this.pageparm.total = res.data.total
		      }
		    })
		  },
        // 获取数据方法
        getdata(pageparm) {
          this.loading = true

          ModuleNodes(pageparm).then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.userData = res.data.menuList
				console.log(999999998,res.data.total)
              // 分页赋值
              this.pageparm.currentPage = this.formInline.pageIndex
              this.pageparm.pageSize = this.formInline.pageSize
              this.pageparm.total = res.data.total
            }
          })
        },
        // 分页插件事件
        callFather(parm) {
          this.formInline.pageIndex = parm.currentPage
          this.formInline.pageSize = parm.pageSize
          this.getdata(this.formInline)
        },
        //搜索事件
        search() {
          this.formInline.pageIndex = 1
          this.getdata(this.formInline)
        },


        // 修改type
        editType: function(index, row) {
          this.loading = true
          let parm = {
            menuCode: '',
            status: ''
          }
          parm.menuCode = row.menuCode
          let lock = row.status
		  console.log(55,lock)
          if (lock == 0) {
            parm.status = 1
          } else {
            parm.status = 0
          }
          // 修改状态
          Modulestate(parm).then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '状态修改成功'
              })
			  this.formInline.parentMenuCode = row.parentCode
              this.getdata(this.formInline)
            }
          })
        },
        //显示编辑界面
        handleEdit: function(index, row) {
          this.editFormVisible = true
          if (row != undefined && row != 'undefined') {
            this.title = '修改菜单'
            ModuleGet (row.menuCode)
              .then(res => {
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg+'TraceId:'+res.traceId
                  })
                } else {
            	  this.editForm.menuName = res.data.menuName
            	  this.editForm.menuCode = res.data.menuCode
            	  this.editForm.type = res.data.type
				  this.editForm.parentCode = res.data.parentCode
            	  this.editForm.sorted = res.data.sorted
				  this.editForm.status = res.data.status.toString()
				  this.editForm.icon = res.data.icon
				  this.editForm.uri = res.data.uri

                }
              })

          } else {
            this.title = '新增菜单'
            this.editForm.menuName = ''
            this.editForm.menuCode = ''
            this.editForm.type = ''
            this.editForm.sorted = ''
            this.editForm.status = ''
			this.editForm.icon = ''
			this.editForm.uri = ''
			this.editForm.parentCode = ''
          }
        },
        // 编辑、添加提交方法
        submitForm(editData) {
          this.$refs[editData].validate(valid => {
            if (valid) {
              // 请求方法
    		  if(this.title=='修改菜单'){

				  let status = parseInt(this.editForm.status)
				  this.editForm.status = status
				  //console.log(typeof(this.editForm.status))
    			  ModuleSave(this.editForm)
    				.then(res => {
    				  this.editFormVisible = false
    				  this.loading = false
    				  if (res.success) {
    					this.getdata(this.formInline)
    					this.$message({
    					  type: 'success',
    					  message: '数据保存成功！'
    					})
    				  } else {
    					this.$message({
    					  type: 'info',
    					  message: res.msg
    					})
    				  }
    				})
    				.catch(err => {
    				  this.editFormVisible = false
    				  this.loading = false
    				  this.$message.error('保存失败，请稍后再试！')
    				})
    			}else{

					let status = parseInt(this.editForm.status)
					this.editForm.status = status
					let sorted = parseInt(this.editForm.sorted)
					this.editForm.sorted = sorted
    				ModuleAdd(this.editForm)
    					.then(res => {
    					  this.editFormVisible = false
    					  this.loading = false
    					  if (res.success) {
    						this.getdata(this.formInline)
    						this.$message({
    						  type: 'success',
    						  message: '数据保存成功！'
    						})
    					  } else {
    						this.$message({
    						  type: 'info',
    						  message: res.msg
    						})
    					  }
    					})
    					.catch(err => {
    					  this.editFormVisible = false
    					  this.loading = false
    					  this.$message.error('保存失败，请稍后再试！')
    					})
    			}
            } else {
              return false
            }
          })
        },

        handleClick(data, checked, node) {
          if (checked) {
            this.$refs.tree.setCheckedNodes([])
            this.$refs.tree.setCheckedNodes([data])
            this.unitparm.deptId = data.id
            this.unitparm.deptName = data.name
            //交叉点击节点
          } else {
          }
        },

        // 选择复选框事件
        selectChange(val) {
          this.selectdata = val
        },
        // 关闭编辑、增加弹出框
        closeDialog(dialog) {
          if (dialog == 'edit') {
            this.editFormVisible = false
          } else if (dialog == 'perm') {
            this.dataAccessshow = false
          } else if (dialog == 'unit') {
            this.unitAccessshow = false
          }
        },
        // 删除用户
        deleteUser(index, row) {
          this.$confirm('确定要删除吗?', '信息', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              // 删除
              ModuleDelete(row.menuCode)
                .then(res => {
                  if (res.success) {
                    this.$message({
                      type: 'success',
                      message: '数据已删除!'
                    })
                    this.getdata(this.formInline)
                  } else {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('数据删除失败，请稍后再试！')
                })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除！'
              })
            })
        }

      }
    }
    </script>

    <style scoped>
    .user-search {
      margin-top: 20px;
    }
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
    }
    </style>





// WEBPACK FOOTER //
// src/views/system/Module.vue